import styled from 'styled-components'

export const LinkExternal = styled.a`
  color: ${props => props.theme.colors.primary};
  font-family: ${props => props.theme.fonts.robotoRegular};
  font-size: ${props => props.theme.fontSizes.linkExternal};
`



// WEBPACK FOOTER //
// ./src/Components/LinkExternal/index.js